import { SVGProps } from 'react';

export const AlertInformationCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_519_21127)">
        <path
          d="M8.99996 17.3571C13.6155 17.3571 17.3571 13.6155 17.3571 9C17.3571 4.38448 13.6155 0.64286 8.99996 0.64286C4.38444 0.64286 0.642822 4.38448 0.642822 9C0.642822 13.6155 4.38444 17.3571 8.99996 17.3571Z"
          stroke="#1C213C"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="path"
        />
        <path
          d="M9 9V13.5"
          stroke="#1C213C"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="path"
        />
        <path
          d="M8.99991 6.42857C9.35495 6.42857 9.64277 6.14076 9.64277 5.78572C9.64277 5.43068 9.35495 5.14286 8.99991 5.14286C8.64487 5.14286 8.35706 5.43068 8.35706 5.78572C8.35706 6.14076 8.64487 6.42857 8.99991 6.42857Z"
          stroke="#1C213C"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="path"
        />
      </g>
      <defs>
        <clipPath id="clip0_519_21127">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
